import React from 'react';
import ReactDOMServer from 'react-dom/server';
import IconCard from '@web-common/components/UI/IconCard';
import { getIn18Text } from 'api';
const actionMap = {};
export const beforeNewWindow = (iframe, type, value) => {
    if (!iframe)
        return;
    const doc = iframe.contentDocument;
    const action = actionMap[type];
    if (action && typeof action === 'function') {
        action(doc, value);
    }
};
export const scaleEditor = (callback) => {
    const toolbar = document.querySelector('.editor-container .tox-toolbar-overlord');
    const scaleBtn = document.querySelector('.editor-container .tox-toolbar__scale__btn');
    if (!scaleBtn) {
        const minSvg = ReactDOMServer.renderToString(React.createElement(IconCard, { type: "minEditor" }));
        const maxSvg = ReactDOMServer.renderToString(React.createElement(IconCard, { type: "maxEditor" }));
        const group = document.createElement('div');
        let inMax = false;
        let buttonDom = null;
        const toMax = `<span class="tox-icon tox-tbtn__icon-wrap">${maxSvg}</span>`;
        const toMin = `<span class="tox-icon tox-tbtn__icon-wrap">${minSvg}</span>`;
        group.addEventListener('click', () => {
            inMax = !inMax;
            if (!buttonDom)
                buttonDom = group.querySelector('button');
            buttonDom.innerHTML = inMax ? toMin : toMax;
            buttonDom.setAttribute('aria-label', inMax ? getIn18Text('ZUIXIAOHUA') : getIn18Text('ZUIDAHUA'));
            callback(inMax);
        });
        group.className = 'tox-toolbar__group tox-toolbar__scale__btn';
        group.innerHTML = `<button aria-label="最大化" title="" aria-haspopup="true" type="button" data-alloy-tabstop="true" tabindex="-1" class="tox-tbtn" aria-expanded="false"><span class="tox-icon tox-tbtn__icon-wrap">${maxSvg}</span></button>`;
        toolbar === null || toolbar === void 0 ? void 0 : toolbar.appendChild(group);
    }
};
export const contentAssitantEditor = (callback, changeShow, destroy) => {
    if (!process.env.BUILD_ISEDM)
        return;
    if (destroy) {
        const assitBtn = document.querySelector('.editor-container .tox-toolbar__content_assistant__btn');
        if (assitBtn) {
            const parentEl = assitBtn.parentElement;
            parentEl === null || parentEl === void 0 ? void 0 : parentEl.removeChild(assitBtn);
        }
        return;
    }
    const toolbar = document.querySelector('.editor-container .tox-toolbar-overlord');
    const toolbarItems = document.querySelector('.editor-container .tox-toolbar-overlord .tox-toolbar');
    const assistBtn = document.querySelector('.editor-container .tox-toolbar__content_assistant__btn .asis-tbtn');
    const leftSvg = ReactDOMServer.renderToString(React.createElement(IconCard, { type: "ContentAssistantLeft" }));
    const rightSvg = ReactDOMServer.renderToString(React.createElement(IconCard, { type: "ContentAssistantRight" }));
    let isShow = false;
    let buttonDom = null;
    const toMax = `<span class="tox-icon tox-tbtn__icon-wrap">${rightSvg}</span>&nbsp;${getIn18Text('NEIRONGZHUSHOU')}`;
    const toMin = `<span class="tox-icon tox-tbtn__icon-wrap">${leftSvg}</span>&nbsp;${getIn18Text('NEIRONGZHUSHOU')}`;
    if (assistBtn && changeShow !== undefined) {
        isShow = assistBtn.classList.contains('asis-tbtn-active');
        if (isShow !== changeShow) {
            isShow = changeShow;
        }
        assistBtn.innerHTML = isShow ? toMin : toMax;
        if (changeShow) {
            assistBtn.classList.add('asis-tbtn-active');
        }
        else {
            assistBtn.classList.remove('asis-tbtn-active');
        }
        return;
    }
    if (!assistBtn) {
        const group = document.createElement('div');
        group.addEventListener('click', () => {
            isShow = buttonDom ? !buttonDom.classList.contains('asis-tbtn-active') : !isShow;
            if (!buttonDom)
                buttonDom = group.querySelector('button');
            buttonDom.innerHTML = isShow ? toMin : toMax;
            if (isShow) {
                buttonDom.classList.add('asis-tbtn-active');
            }
            else {
                buttonDom.classList.remove('asis-tbtn-active');
            }
            callback(isShow);
        });
        group.className = 'tox-toolbar__group tox-toolbar__content_assistant__btn';
        group.innerHTML = `<button title="" aria-haspopup="true" type="button" data-alloy-tabstop="true" tabindex="-1" class="tox-tbtn asis-tbtn ${destroy === false ? changeShow && 'asis-tbtn-active' : ''}" aria-expanded="false">${destroy === false ? (changeShow && toMin) || toMax : toMax}</button>`;
        if (process.env.BUILD_ISELECTRON) {
            group.style.right = '10px';
            toolbarItems && (toolbarItems.style.paddingRight = '80px');
        }
        else {
            toolbarItems && (toolbarItems.style.paddingRight = '120px');
        }
        toolbar === null || toolbar === void 0 ? void 0 : toolbar.appendChild(group);
    }
};
export const filterSVGScript = (file) => {
    return new Promise((resolve, reject) => {
        const fileName = file.name;
        if (fileName && fileName.endsWith('.svg')) {
            const reader = new FileReader();
            reader.onload = res => {
                if (typeof reader.result !== 'string') {
                    resolve(file);
                    return;
                }
                const str = reader.result.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
                const blob = new Blob([str], { type: file.type });
                const filterFile = new File([blob], file.name, { type: file.type });
                resolve(filterFile);
            };
            reader.readAsText(file);
            return;
        }
        resolve(file);
    });
};
